"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthentication = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const react_1 = require("react");
const components_common_cross_tab_1 = require("@hotelplan/components.common.cross-tab");
const fdr_lib_context_request_1 = require("@hotelplan/fdr.lib.context.request");
const fdr_lib_context_request_util_1 = require("@hotelplan/fdr.lib.context.request-util");
const fdr_lib_ident_auth_config_1 = require("@hotelplan/fdr.lib.ident.auth-config");
const auth_context_1 = require("./auth.context");
function useAuthentication() {
    const updateHeaders = (0, fdr_lib_context_request_1.useRequestContextUpdate)();
    const { user, client: auth } = (0, auth_context_1.useAuthContext)();
    const { broadcast } = (0, components_common_cross_tab_1.useCrossTabBroadcast)(fdr_lib_ident_auth_config_1.AUTH_CROSS_TAB_BROADCAST_CHANNEL_KEY);
    return (0, react_1.useMemo)(() => ({
        userId: user === null || user === void 0 ? void 0 : user.userId,
        channelType: user === null || user === void 0 ? void 0 : user.channel,
        logout() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const logoutResponse = yield auth.logout();
                    // NOTE: We should reset B2B Markup field on log out.
                    updateHeaders(prev => (Object.assign(Object.assign({}, prev), { b2bMarkup: undefined })));
                    if (typeof window !== 'undefined') {
                        js_cookie_1.default.remove(fdr_lib_context_request_util_1.B2B_MARKUP_KEY);
                    }
                    if (((_a = logoutResponse.payload) === null || _a === void 0 ? void 0 : _a.channelType) === fdr_lib_ident_auth_config_1.AuthChannelType.B2CAnonymous) {
                        broadcast({ logout: true });
                    }
                }
                catch (e) {
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.error(`Logout Error`, e);
                    }
                    // ignore missing typename when store is removed
                }
            });
        },
    }), [auth, user, broadcast, updateHeaders]);
}
exports.useAuthentication = useAuthentication;
//# sourceMappingURL=useAuthentication.js.map